<template>
  <aside class="popup-form campaign-clients-popup" role="dialog" aria-labelledby="campaign-clients-title">
    <div class="content-form-popup">
      <div class="header-text">
        <button ref="closeButton" type="button" class="back-button-wrapper pointer" :aria-label="payload.closeLabel || 'Zavrieť registrácie kampane'" @click="closePopup">
          <app-icon name="close" :size="24" />
        </button>
        <h2 id="campaign-clients-title">{{ payload.title || 'Registrácie kampane' }}</h2>
      </div>
      <h3>{{ payload.name }}</h3>
      <p class="campaign-period">{{ payload.leads }} registrácií · {{ payload.days }} dní</p>
      <p v-if="payload.note" class="campaign-period">{{ payload.note }}</p>
      <ul v-if="payload.clients.length" class="campaign-clients">
        <li v-for="client in payload.clients" :key="client.id">
          <button type="button" class="campaign-client" :disabled="!client.user_id" :aria-label="'Otvoriť klienta ' + client.name" @click="openClient(client)">
            <strong>{{ client.name }}</strong>
            <span>{{ (client.property_locations || []).join('; ') || 'Lokácia nehnuteľnosti nie je vyplnená' }}</span>
            <small v-if="client.user_id">Otvoriť klienta →</small>
          </button>
        </li>
      </ul>
      <p v-else class="campaign-period">{{ payload.emptyMessage || 'V tomto období nemá kampaň žiadne registrácie.' }}</p>
    </div>
  </aside>
</template>

<script>
import AppIcon from '@/components/shared/AppIcon.vue';
export default {
  name: 'CampaignClientsPopUp',
  components: {AppIcon},
  props: {payload: {type: Object, required: true}},
  mounted() {this.$refs.closeButton.focus();},
  methods: {
    openClient(client) {
      if (!client.user_id) return;
      this.$store.commit('popupManagerState/pushToPopupOrder', {
        component: 'UserManagerPopUp',
        payload: {id: client.user_id},
        type: {clients: true, client: true},
        rules: [],
      });
    },
    closePopup() {this.$store.commit('popupManagerState/popItemFromPopupOrder');},
  },
};
</script>

<style scoped>
.campaign-clients-popup{color:var(--app-text);background:var(--app-bg)}
.header-text{gap:12px;align-items:center}
h2{font-size:20px;margin:0;color:var(--app-text)}
h3{font-size:20px;margin:20px 0 8px;overflow-wrap:anywhere;color:var(--app-text)}
.campaign-period{color:var(--app-text-muted);font-size:13px;line-height:1.5}
.campaign-clients{padding:0;margin:20px 0;list-style:none}
.campaign-clients li{margin-bottom:10px}
.campaign-client{display:block;width:100%;padding:14px;text-align:left;font:inherit;border:1px solid var(--app-border);border-radius:10px;background:var(--app-surface);color:var(--app-text);cursor:pointer;overflow-wrap:anywhere;transition:background .15s,border-color .15s}
.campaign-client:hover{background:var(--app-surface-muted);border-color:var(--app-primary)}
.campaign-client strong{display:block;font-size:14px}
.campaign-client span{display:block;margin-top:5px;font-size:13px;line-height:1.5;color:var(--app-text-muted)}
.campaign-client small{display:block;margin-top:8px;color:var(--app-primary);font-size:12px}
.campaign-client:disabled{cursor:default}
button:focus-visible{outline:2px solid var(--app-primary);outline-offset:3px}
.back-button-wrapper{background:transparent;border:0;color:var(--app-primary)}
</style>
